import React, {useEffect, useState} from 'react';
import SongItem from '../../SongItem/SongItem';
import SongItemWrapper  from '../../SongItemWrapper/SongItemWrapper'
import { Container, Row , Col } from 'reactstrap';
import defaultSongImg from '../images/defaultSong.svg';

const EmptyPlayListDefault = (props) => {
    
    useEffect(() => {
 
    },[])

    return (
        <Container className="songs-with-contacts">
            <Row>
                <Col xs="12" sm="12" md="6">
                    <h3>השירים שמשוייכים לאנשי קשר</h3>
                </Col>
            </Row>
                <Row >
                    <Col xs="12" sm="12" md="6">
                    <div className="songs-with-contacts-item">
                        <SongItemWrapper  songId={"empty"} isDefaultSong={false} isDownloadMode={false} >
                            <SongItem isDisplayPlayer={false} playerSize={87} isDetailsFromLeft={true} onClickSong={()=> {}} audio={{ id: "empty", title: null, subtitle: null, image: defaultSongImg, audio: null }} ></SongItem>
                        </SongItemWrapper>
                    </div>
                    </Col>
                </Row>            
        </Container>) ;
}

export default EmptyPlayListDefault;


